import React from 'react'

export function LogoutIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M21.75 21a.75.75 0 01-.75.75h-8.996a.75.75 0 110-1.5h8.246V3.75H12a.75.75 0 010-1.5h9a.75.75 0 01.75.75v18zM8.03 17.03a.75.75 0 01-1.06 0l-4.5-4.5a.75.75 0 010-1.06l4.5-4.5a.75.75 0 011.06 1.06L4.06 12l3.97 3.97a.75.75 0 010 1.06z"
        clipRule="evenodd"
      />
      <path
        fill="#FFFFFF"
        fillRule="evenodd"
        d="M16.75 12.004a.75.75 0 01-.75.75H3a.75.75 0 010-1.5h13a.75.75 0 01.75.75z"
        clipRule="evenodd"
      />
    </svg>
  )
}
